import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import { MoreVert } from "@material-ui/icons";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useCurrentUser from "qpr-base/context/UserContext";
import useLink from "qpr-base/hooks/useLink";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { If } from "react-if";
import { useClickAway } from "react-use";
import { ReactComponent as ShareIcon } from "../assets/mydashboard_share_icon.svg";
import { Dashboard } from "../types/api";
const useStyles = (isRtl: boolean) =>
  makeStyles({
    tableContainer: {
      boxShadow: "none",
      borderRadius: "18px",
    },
    table: {
      minWidth: 650,
      "& .MuiTableRow-root td:not(:first-child)": {
        borderInlineStart: "1px solid #DCDEE2",
        maxWidth: "150px",
        width: "15%",
      },
      "& .MuiTableRow-root td:last-child": {
        textAlign: "center",
        width: "95px",
        maxWidth: "95px",
      },
      "& .MuiTableRow-root": {
        borderBottom: "none",
      },
      "& .MuiTableRow-root td:first-child": {
        maxWidth: "500px",
      },
      "& .MuiTableRow-root td": {
        backgroundColor: "#fbfbfc",
        borderTop: "none",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        borderBottom: "none",
      },
      "& tr th:not(:first-child)": {
        borderInlineStart: "1px solid #DCDEE2",
        backgroundColor: "white",
      },
    },
    moreBtn: {
      backgroundColor: "white",
      padding: "5px",
      borderRadius: "5px",
      width: "30px",
      margin: "auto",
      cursor: "pointer",
      display: "flex",
      justifyContent: "center",
      "&:hover": {
        background: "#3d3a4b1c",
      },
    },
    editIcon: {
      fill: "rgb(0,100,216)",
    },
    simpleMenu: {
      direction: isRtl ? "rtl" : "ltr",
      "& svg": {
        color: "rgb(0, 169, 163)",
        marginInlineEnd: "5px",
        width: "24px",
        height: "24px",
      },
      "& .MuiMenuItem-root:hover": {
        css: {
          backgroundColor: "red",
        },
      },
      "& span": {
        fontFamily: "Dubai",
        fontSize: "1.4rem",
      },
      "& li:not(:last-child)": {
        color: "rgba(0,0,0,.87)",
      },
      "& li:last-child": {
        color: "red",
      },
      "& li:last-child svg": {
        color: "red !important",
      },
    },
  });

interface MoreBtnProps {
  dashboard: Dashboard;
  id: string;
  onDelete?: VoidFunction;
  onEdit?: VoidFunction;
  onShare?: VoidFunction;
}
const MoreBtn: FunctionComponent<MoreBtnProps> = (props) => {
  const { rtl } = useAppContext();
  const classes = useStyles(rtl)();
  const user = useCurrentUser();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const link = useLink({ noPeriod: true });
  const ref = React.useRef(null);

  useClickAway(ref, () => {
    setAnchorEl(null);
  });
  function onMoreClicked(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  }

  function onEdit() {
    setAnchorEl(null);
    link({ page: "editdashboard", meaId: props.id });
  }
  function onShare() {
    if (props.onShare) props.onShare();
    setAnchorEl(null);
  }
  function onDelete() {
    if (props.onDelete) props.onDelete();
    setAnchorEl(null);
  }
  function onClose() {
    setAnchorEl(null);
  }

  if (user.profile?.meaUserId !== props.dashboard.creatorID) {
    return null;
  }
  return (
    <div
      ref={ref}
      className={classes.moreBtn}
      onClick={(ev: any) => onMoreClicked(ev)}
      role="button"
      tabIndex={0}
      onKeyDown={() => {}}
    >
      <MoreVert />
      <Menu
        className={classes.simpleMenu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => onClose()}
      >
        <If condition={props.onShare !== undefined}>
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              onShare();
            }}
          >
            <ShareIcon /> <span>{t("buttons.Sharing")}</span>
          </MenuItem>
        </If>
        <If condition={props.onEdit !== undefined}>
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
          >
            <EditOutlinedIcon className={classes.editIcon} />{" "}
            <span>{t("buttons.Edit")}</span>
          </MenuItem>
        </If>
        <If condition={props.onDelete !== undefined}>
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <DeleteOutlineOutlinedIcon /> <span>{t("buttons.Delete")}</span>
          </MenuItem>
        </If>
      </Menu>
    </div>
  );
};

export default MoreBtn;
